import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "react-jss";
import Select from "../select/Select";
import useStyles from "./TopNavigation.styles";
import { StoreState } from "../../models/states/StoreState";
import Button from "../shared/Button";
import useTranslatable from "../../hooks/useTranslatable";
import { ThemeModel } from "../../models/ThemeModel";
import { changeLanguage } from "../../redux/actions";
import { CULTURE_INFO } from "../../utils/lang";
import { QueryParameters } from "../../consts";
import { getIdForAriaLabelledFieldBySection } from "../../utils/WCAGHelper";

interface Props {
    theme: ThemeModel;
    showSecurityQuestion: boolean;
}

export default function TopNavigation(props: Props) {
    const { theme: surveyTheme, showSecurityQuestion } = props;
    const theme: any = useTheme();
    const classes = useStyles({ theme });
    const {
        LanguageSelectorVisible,
        ViewResponsesButtonVisible,
        LanguageSelectorLabelActive,
    } = theme;

    const dispatch = useDispatch();
    const language = useSelector((state: StoreState) => state.interview.language);
    const languages = useSelector((state: StoreState) => state.interview.questionnaire.languages);
    const viewResponsesText = useTranslatable(surveyTheme, "PrintResponsesButton");
    const languageSelectorTranslatedText = useTranslatable(surveyTheme, "LanguageSelector");

    function viewResponses() {
        let url = window.location.href;
        let win = null;

        if (url.includes(`/S2`)) {
            url =
                url.split(`/S2`)[0] + `/S2/Responses/Index?${QueryParameters.LANGUAGE}=${language}`;
        } else {
            url = `Responses/Index?${QueryParameters.LANGUAGE}=${language}`;
        }

        const psid = document.querySelector<HTMLInputElement>("#S2_SessionId")?.value;
        const skey = document.querySelector<HTMLInputElement>("#S2_SessionId_Skey")?.value;

        if (psid) {
            url += `&${QueryParameters.PAGE_SESSION_ID}=${psid}`;
        }
        if (skey) {
            url += `&${QueryParameters.SESSION_KEY}=${skey}`;
        }

        win = window.open(url);
        if (win) win.focus();
    }
    const listboxAriaLabelId = getIdForAriaLabelledFieldBySection("NAVLANGSELECTOR");

    const languageSelectorLabel = LanguageSelectorLabelActive && (
        <span id={listboxAriaLabelId}>{languageSelectorTranslatedText}</span>
    );

    return (
        <nav className={classes.topNavigation}>
            {ViewResponsesButtonVisible && !showSecurityQuestion && (
                <Button
                    className="top-navigation__view-responses"
                    text={viewResponsesText}
                    onClick={viewResponses}
                    size="small"
                    buttonType="VIEW_RESPONSES"
                />
            )}

            {LanguageSelectorVisible && (
                <>
                    {languageSelectorLabel}
                    <Select
                        id="LANGUAGE_SELECTOR_INPUT"
                        className={classes.languageSelector}
                        value={[language]}
                        onChange={(code) => dispatch(changeLanguage(code[0]))}
                        icon="globe"
                        disabled={languages.length < 2}
                        ariaDisabledBy={languages.length < 2}
                        options={languages.map((code) => {
                            const info = CULTURE_INFO[code.toLowerCase()];
                            const isFrench = language === "fr";
                            const label = isFrench
                                ? `${info.nativeName !== info.name_fr ? info.name_fr + " (" + info.nativeName + ")" : info.name_fr}`
                                : `${info.nativeName !== info.name ? info.name + " (" + info.nativeName + ")" : info.name}`;
                            return {
                                id: `LANGUAGE_SELECTOR_INPUT_${code.toUpperCase()}`,
                                label,
                                value: code,
                            };
                        })}
                        listboxAriaLabelId={languageSelectorLabel ? listboxAriaLabelId : null}
                    />
                </>
            )}

        </nav>
    );
}
